import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import SalesInsightsAreaSales from "./SalesInsightAreaSales";
import SalesByTender from "./SalesByTender";
import NetMargin from "./NetMarginExcTax";
import NetMarginByLocation from "./NetMarginByLocation";
import NetSalesByLocation from "./NetSalesByLocation";
import NateMarginRate from "./NetMarginRate";
import SalesByProduct from "./SalesByProduct";
import SalesIncTaxNetSalesExcTax from "./SalesIncTaxNetSalesExcTax";
import NetMarginByProduct from "./NetMarginByProduct";

const SalesOverviewDashboard = () => {
    const salesAreaRef = useRef<HTMLDivElement>(null);
    const [salesByStaffHeight, setSalesByStaffHeight] = useState<number>(487);
    
    useEffect(() => {
        if (!salesAreaRef.current) return undefined;

        const resize = () => {
            setSalesByStaffHeight(() => salesAreaRef.current?.clientHeight || 487)
        }

        const observer = new ResizeObserver(resize)
        observer.observe(salesAreaRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <Box sx={{ width: '100%', flexGrow: 1, height: 'auto' }}>
            <Box sx={{ marginY: '20px', display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                <Box ref={salesAreaRef} sx={{ width: '25%' }}>
                    <SalesInsightsAreaSales />
                </Box>
                <Box sx={{ display: 'flex', width: '75%', height: salesByStaffHeight }}>
                    <SalesByProduct />
                </Box>
            </Box>
            <Box sx={{ marginY: '20px', display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ width: '50%', display: 'flex' }}>
                    <SalesIncTaxNetSalesExcTax />
                </Box>
                <Box sx={{ width: '50%', display: 'flex' }}>
                    <SalesByTender />
                </Box>
            </Box>
            <Box sx={{ marginY: '20px', display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ width: '50%', display: 'flex' }}>
                    <NetMargin />
                </Box>
                <Box sx={{ width: '50%', display: 'flex' }}>
                    <NateMarginRate />
                </Box>
            </Box>
            <Box sx={{ marginY: '20px', display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ width: '50%', display: 'flex' }}>
                    <NetMarginByLocation />
                </Box>
                <Box sx={{ width: '50%', display: 'flex' }}>
                    <NetSalesByLocation />
                </Box>
            </Box>
            <Box sx={{ marginY: '20px' }}>
                <NetMarginByProduct />
            </Box>
        </Box>
    );
};

export default SalesOverviewDashboard;
